import React from 'react';
import {
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  Button,
  Badge,
  BankIcon,
  CloseIcon,
  Divider,
} from '@razorpay/blade/components';

export const InvalidBankDetailsModal = ({
  isOpen,
  onDismiss,
  onContinue,
  accountDetails,
}: {
  isOpen: boolean;
  onDismiss: () => void;
  onContinue: () => void;
  accountDetails?: {
    accountNumber: string;
    ifscCode: string;
  };
}) => {
  const { accountNumber, ifscCode } = accountDetails || {};

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} size="small">
      <ModalHeader
        title="Invalid Bank Account Details"
        subtitle="The bank details provided are not valid. Please try again"
      />
      <ModalBody>
        <Box
          padding="spacing.5"
          borderRadius="large"
          borderColor="surface.border.gray.subtle"
          borderWidth="thin">
          <Box marginBottom="spacing.3" display="flex" alignItems="center" gap="spacing.3">
            <BankIcon color="surface.icon.gray.subtle" />
            <Text weight="semibold" size="small">
              A/c no: {accountNumber}
            </Text>
            <Badge color="negative" icon={CloseIcon}>
              Invalid
            </Badge>
          </Box>
          <Box display="flex" alignItems="center" gap="spacing.3">
            <Divider variant="normal" marginX="spacing.3" width="thin" orientation="vertical" />
            <Box display="flex" flexDirection="column" gap="spacing.2">
              <Text size="small" color="surface.text.gray.muted">
                IFSC code: {ifscCode}
              </Text>
            </Box>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.5" justifyContent="flex-end">
          <Button variant="tertiary" onClick={onDismiss}>
            Close
          </Button>
          <Button onClick={onContinue}>Try Again</Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
